import { useCurrentUser } from '../../contexts/UserContext';
import QuickTiles from './sections/QuickTiles';
import UpcomingClasses from './sections/UpcomingClasses';
import StudentRoster from './sections/StudentRoster';

export default function TeacherDashboard() {
  const currentUser = useCurrentUser();

  return (
    <div className="dashboard-content">
      <div className="welcome-inline">
        <h2>Welcome, {currentUser?.name?.split(' ')[0] || 'back'}!</h2>
      </div>

      <div className="main-feed">
        <QuickTiles />

        <div className="dual-panels">
          <UpcomingClasses />
        </div>

        <StudentRoster />
      </div>
    </div>
  );
}
